<template>
    <div>
        <div class="rtitle flex justify-between align-center bg-white rone">
            <div class="colorleft">企业服务</div>
            <div class="colorright">
                <div @click="toapply" class="t_btn pointer">提出需求</div>
            </div>
        </div>
        <div class="cball">
            <div class="" v-if="list.length" style="min-height: 570px;">
                <el-row :gutter="15">
                    <el-col v-for="(item,index) in list" :key="index" :span="8">
                        <div @click="todetail(index)" class="l_one bg-white">
                            <div class="l_top">
                                <div class="l_title flex justify-start align-center">
                                    <div class="l_line"></div>
                                    <div class="l_text text-cut">{{item.title}}</div>
                                </div>
                                <div class="l_brief text-cut5">{{item.content}}</div>
                            </div>
                            <div class="l_bot flex justify-between align-center">
                                <div class="l_time">{{item.createtime}}</div>
                                <div v-if="item.status == 0" class="l_tip l_color1">未处理</div>
                                <div v-if="item.status == 1" class="l_tip l_color2">处理中</div>
								<div v-if="item.status == 2" class="l_tip l_color2">已办结</div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div class="text-center" style="padding-top: 40px;">
                        <el-pagination
                        background
                        layout="prev, pager, next"
                        :pager-count="pagerCount"
                        :hide-on-single-page="true"
                        :page-size="pagesize"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :total="totalnum"
                        >
                        </el-pagination>
                </div>
            </div>
            <div v-if="!list.length && !load" class="bg-white" style="min-height: 480px;padding: 40px;">
                <el-empty description="暂无数据"></el-empty>
            </div>
        </div>
        <el-dialog title="详情" :visible.sync="showdetail">
            <div class="" >
                <div>
                    <div class="">
                        <div class="l_title flex justify-start align-center">
                            <div class="l_line"></div>
                            <div class="l_text">提交内容</div>
                        </div>
						<div class="new_brief"><div class="" style="color: #8a8a8a;font-size: 16px;margin: 6px 0;margin-right: 10px;">
							提交标题：
						</div>{{showdata.title}}</div>
                        <div class="new_brief"><div class="" style="color: #8a8a8a;font-size: 16px;margin: 6px 0;margin-right: 10px;">
							提交简述：
						</div>{{showdata.content}}</div>
                    </div>
                    <div>
						<div class="" style="color: #8a8a8a;font-size: 16px;margin: 6px 0;margin-right: 10px;margin-bottom: 20px;">
							提交图片：
						</div>
                        <el-row :gutter="15">
                            <el-col v-for="(items,indexs) in showdata.file" :key="indexs" :span="8">
                                <div>
                                    <el-image style="width: 250px;height: 250px;margin-bottom: 15px;" :src="items" fit="fill"></el-image>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="showdata.remark" class="">
                        <div class="l_title flex justify-start align-center">
                            <div class="l_line"></div>
                            <div class="l_text">平台反馈</div>
                        </div>
                        <div class="new_brief">
						<div class="" style="color: #8a8a8a;font-size: 16px;margin: 6px 0;margin-right: 10px;">
							回复内容：
						</div>
						{{showdata.remark}}</div>
						<template v-if="showdata.hffile">
							<div style="display: flex;align-items: center;">
								<div class="" style="color: #8a8a8a;font-size: 16px;margin: 6px 0;margin-right: 10px;">
									回复附件：
								</div>
								<div style="padding: 10px 0px;" class="text-cut2">
									<a style="display: flex;align-items: center;color: #b6b5b5;text-decoration:none"
										target="_blank" :href="showdata.hffile | addurl">
										<img src="../../../static/assets/images/wenjian.png"
											style="width:40px;height:40px;margin-right: 10px;" />
										点击打开
									</a>
								</div>
							</div>
						</template>
                    </div>
                </div>
                
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default({
    data() {
        return{
            pagerCount: 7,
            pagesize: 6,
            totalnumnew: 0,
            currentPage: 1,
            totalnum: 100,
            list: [],
            load: true,
            usreinfo: '',
            showdetail: false,
            showdata: ''
        }
    },
    methods:{
        todetail(index){
            console.log(123123123)
            
            this.showdata = this.list[index];
            this.showdetail = true;
        },
        toapply(){
            this.$router.push({name: 'apply'})
        },
        handleSizeChange(){

        },
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
            this.getlist();
        },
        getlist(){
            var data = {
                shop_id: this.usreinfo.shop.id,
                start: this.currentPage,
                page_size: this.pagesize
            }
            this.$api.index.feedback_list(data).then(res=>{
                for(let i in res.data){
                    if(res.data[i].file){
                        res.data[i].file = res.data[i].file.split(',')
                    }
                }
                this.list = res.data;
                this.totalnum = res.count;
                this.load = false;
            }).catch(res=>{
                // console.log(res,1111111111)
                this.load = false;
            })
        },
    },
    created(){
        this.usreinfo = JSON.parse(localStorage.getItem('userinfo'));
        this.getlist();
    }
})
</script>

<style scoped>
    .rtitle{
        padding: 10px 20px;
        font-size: 16px;
        color: #7d7d7d;
        border-bottom: 8px solid #f4f4f4;
    }
    .rone{
        border-radius: 12px;
    }
    .colorleft{
        color: #191919;font-size: 20px;
    }
    .colorright{
        color: #7e7e7e;font-size: 18px;
    }

    .l_one{
        border-radius: 12px;margin-bottom: 15px;
    }
    .l_top{
        padding: 30px 20px;border-bottom: 1px solid #eee;
    }
    .l_title{
        margin-bottom: 25px;
    }
    .l_line{
        width: 3px;
        height: 22px;
        background-color: #1759d8;
    }
    .l_text{
        color: #1b1b1b;font-size: 20px;margin-left: 10px;
        width: 80%
    }
    .l_brief{
        color: #5e5e5e;font-size: 17px;line-height: 32px;min-height: 160px;
    }
    .new_brief{
        color: #5e5e5e;font-size: 17px;line-height: 32px;margin-bottom:15px;display: flex;align-items: center;
    }
    .l_bot{
        height: 60px;padding: 0 20px;
    }
    .l_time{
        color: #b9b9b9;font-size: 15px;
    }
    .l_tip{
        width: 60px;
        height: 24px;
        border-radius: 4px;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
    }
    .l_color1{
        background-color: #fff7e8;color: #ffa81f;
    }
    .l_color2{
        background-color: #e2fbfa;color: #00bfab;
    }
    .t_btn{
        width: 138px;
        height: 46px;
        background-color: #1759d8;
        border-radius: 4px;
        text-align: center;
        line-height: 46px;
        color: #ffffff;
        font-size: 18px;
    }
</style>


// WEBPACK FOOTER //
// service.vue?0a881044